import { useCallback, useEffect, useState } from 'react'
import { format, isToday, isYesterday, parseISO } from 'date-fns';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const useFormattedTime = (date) => {
    const [formattedDate,setFormattedDate] = useState("")

    const formatDate = useCallback(() => {
      if (date) {
          const parsedDate = typeof date === 'string' ? parseISO(date) : date;

          if (isToday(parsedDate)) {
              setFormattedDate(`Today, ${format(parsedDate, 'hh:mm aa')}`);
          }
          else if (isYesterday(parsedDate)) {
              setFormattedDate(`Yesterday, ${format(parsedDate, 'hh:mm aa')}`);
          }
          else {
            const day = `${format(parsedDate, 'dd')} ${months[parsedDate.getMonth()]} ${format(parsedDate, 'yyyy')}`
            const time = format(parsedDate, 'hh:mm aa');
            setFormattedDate(day + ", " + time );
          }
      }
      else{
        return ""
      }
    },[date])


    useEffect(() => {
      let intervalId
      let shouldContinue = formatDate()
      if (shouldContinue){
        intervalId = setInterval(()=>{
          shouldContinue = formatDate()
          if (!shouldContinue) clearInterval()
        }, 60000)
      }

      return () => {
        if (intervalId) clearInterval(intervalId)
      }
    }, [formatDate]);

  return formattedDate
}

export default useFormattedTime